import { pdkAxios } from '@/lib/pdk-axios';
import { CustomerLead } from '@/models/registry';
import type { CustomerLead as CustomerLeadType } from '@/models/types';
import { makeAutoObservable } from 'mobx';
import { db } from '../db';
import type { DeltaPacketRecord } from '../hydrate';

export class LeadStore {
  store: Map<string, CustomerLead> = new Map();

  constructor() {
    makeAutoObservable(this);
  }

  get all(): CustomerLead[] {
    return Array.from(this.store.values());
  }

  applyDelta({ delta }: { delta: DeltaPacketRecord<CustomerLeadType> }) {
    this.store.delete(delta.record_id);

    this.add(delta.data);
    db.customer_leads.put(delta.data, delta.record_id);
  }

  add(input: CustomerLeadType) {
    const customerLead = new CustomerLead(input);
    this.store.set(customerLead.id, customerLead);
  }

  async hydrateLocal() {
    const leads = await db.customer_leads.toArray();
    leads.forEach((lead) => this.add(lead));
  }

  async hydrateRefresh() {
    await db.customer_leads.clear();
    await pdkAxios.get('/leads');
  }
}

export const leadStore = new LeadStore();
